export const environment = {
  production: false,
  apiUrl: 'https://barter-admin.imoks.dev/api',
  clerkPublishableKey: 'pk_test_aG9uZXN0LXN0YXJsaW5nLTc4LmNsZXJrLmFjY291bnRzLmRldiQ',
  buildNumber: '6466',
  enableTestData: false,
};
